import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { ScrollProvider } from '@/components/motion/ScrollProvider';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { ScrollProgress } from '@/components/motion/ScrollProgress';
import { CursorCompanion } from '@/components/motion/CursorCompanion';
import { HomePage } from '@/routes/HomePage';
import { ProjectsPage } from '@/routes/ProjectsPage';
import { ProjectDetailPage } from '@/routes/ProjectDetailPage';
import { ServicesPage } from '@/routes/ServicesPage';
import { JournalPage } from '@/routes/JournalPage';
import { JournalPostPage } from '@/routes/JournalPostPage';
import { AboutPage } from '@/routes/AboutPage';
import { ContactPage } from '@/routes/ContactPage';
import { PrivacyPage } from '@/routes/PrivacyPage';
import { TermsPage } from '@/routes/TermsPage';
import { NotFoundPage } from '@/routes/NotFoundPage';
import { initAnalytics, trackPage } from '@/lib/analytics';

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPage(location.pathname);
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [location.pathname]);
  return null;
}

export function ShellInner() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  return (
    <>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <CursorCompanion />
      {!isHome ? <ScrollProgress /> : null}
      <Header overCinema={isHome} />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:slug" element={<ProjectDetailPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/journal" element={<JournalPage />} />
          <Route path="/journal/:slug" element={<JournalPostPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <PageTracker />
    </>
  );
}

export default function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <BrowserRouter>
      <ScrollProvider>
        <ShellInner />
      </ScrollProvider>
    </BrowserRouter>
  );
}
